export class MissingInputError extends Error {
  constructor(inputName: string) {
    super(`Missing required input: ${inputName}`);
    this.name = 'MissingInputError';
  }
}
